import { createAction, props } from '@ngrx/store';
import {
  FormMode,
  NotificationContentProps,
  NotificationContentErroredProps,
  NotificationContentLoadedProps,
} from './types';
import { NotificationContentBody } from '../notification-content/types';

const Type = '[Notification Content Form]';

export const NotificationContentFormErroredAction = createAction(
  `${Type} Errored`,
  props<NotificationContentErroredProps>(),
);

export const NotificationContentFormModeChangedAction = createAction(
  `${Type} Form Mode Changed`,
  props<{ mode?: FormMode }>(),
);

export const CreateNotificationContentFormAction = createAction(
  `${Type} Create`,
  props<NotificationContentProps<NotificationContentBody>>(),
);
export const NotificationContentFormCreatedAction = createAction(
  `${Type} Created`,
  props<NotificationContentLoadedProps>(),
);

export const UpdateNotificationContentFormAction = createAction(
  `${Type} Update`,
  props<NotificationContentProps<NotificationContentBody> & { id: number }>(),
);
export const NotificationContentFormUpdatedAction = createAction(
  `${Type} Updated`,
  props<NotificationContentLoadedProps>(),
);

export const NotificationContentFormLoadAction = createAction(
  `${Type} Load`,
  props<{ notificationContentId: number }>(),
);
export const NotificationContentFormLoadSucceededAction = createAction(
  `${Type} Load Succeeded`,
  props<NotificationContentLoadedProps>(),
);
export const NotificationContentFormLoadErroredAction = createAction(
  `${Type} Load Errored`,
  props<NotificationContentErroredProps>(),
);
